module.exports = __webpack_public_path__ + "static/media/eye.8d00b0ed.svg";